import { render, staticRenderFns } from "./DataProcessors.vue?vue&type=template&id=2e4cac8e&scoped=true&"
import script from "./DataProcessors.vue?vue&type=script&lang=js&"
export * from "./DataProcessors.vue?vue&type=script&lang=js&"
import style0 from "./DataProcessors.vue?vue&type=style&index=0&id=2e4cac8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4cac8e",
  null
  
)

export default component.exports